import { createFileRoute } from "@tanstack/react-router";
import { CategoryListing } from "@/components/venues/CategoryListing";

export const Route = createFileRoute("/_categories/open-spaces")({
  head: () => ({
    meta: [
      { title: "Spacious Open-Air Gardens & Lawns in Oyo State — OyoBooking" },
      {
        name: "description",
        content:
          "Find and reserve spacious outdoor lawns, parks, rooftop gardens and open-air event grounds in Oyo State, Nigeria.",
      },
    ],
    links: [{ rel: "canonical", href: "https://oyobooking.ng/open-spaces" }],
  }),
  component: () => <CategoryListing category="open-space" />,
});
